const mq = {small: '@media (max-width: 991px)'}

export default mq
